import { APP_NAME } from "@constants/app-defaults";

export const DEFAULT_SERVER_SIDE_CACHE_HEADER = "public, s-maxage=10, stale-while-revalidate=59";

export const PRISMIC_CONFIG = {
  appName: APP_NAME,
};

export const DISALLOW_SSR_PATHS = ["*/cart*", "*/orders/*", "*/plasmic-host*"];
